export type ChatScrollKey = string | number | bigint;

export type ChatScrollRow = {
  key: ChatScrollKey;
  start: number;
  size: number;
};

export type ChatScrollAnchor = {
  key: ChatScrollKey;
  offset: number;
};

export function readVisibleScrollAnchor({
  scrollTop,
  rows,
}: {
  scrollTop: number;
  rows: readonly ChatScrollRow[];
}): ChatScrollAnchor | null {
  const visible = rows.find((row) => row.start + row.size > scrollTop);

  if (!visible) {
    return null;
  }

  return {
    key: visible.key,
    offset: scrollTop - visible.start,
  };
}

export function scrollTopForAnchor({
  anchor,
  rows,
}: {
  anchor: ChatScrollAnchor;
  rows: readonly ChatScrollRow[];
}): number | null {
  const row = rows.find((entry) => entry.key === anchor.key);

  if (!row) {
    return null;
  }

  return row.start + anchor.offset;
}

export function shouldAdjustChatScrollForRowResize({
  itemEnd,
  scrollOffset,
}: {
  itemEnd: number;
  scrollOffset: number;
}): boolean {
  return itemEnd <= scrollOffset;
}
